export const version = '0.0.0';
export const buildTime = 'Wed Dec 17 2025 17:26:01 GMT+0100 (Central European Standard Time)';
export const sourceUrl = 'https://github.com/CentreForDigitalHumanities/data-donation/tree/e06cbc64e4a4b2cd794e25ac13c0cdef232e4fbe';
